<forge-toolbar slot="header" *ngIf="(chromeless$ | async) === false">
  <xng-breadcrumb [separator]="iconTemplate" slot="start"></xng-breadcrumb>
  <ng-template #iconTemplate>
    <forge-icon name="keyboard_arrow_right"></forge-icon>
  </ng-template>
</forge-toolbar>
<div class="admin-container">
  <router-outlet></router-outlet>
</div>